import React, { FC } from 'react';
import classNames from 'classnames';

interface CounterProps {
  count: number;
  maxCount?: number;
  onAddClick: () => void;
  onSubtractClick: () => void;
}

const Counter: FC<CounterProps> = function Counter({
  count,
  maxCount,
  onAddClick,
  onSubtractClick,
}) {
  const maxCountReached = count >= (maxCount ?? Infinity);

  return (
    <div
      className={classNames('pdp-options__counter', {
        'pdp-options__counter--expanded': count > 0,
        'pdp-options__counter--max-count-reached': maxCountReached,
      })}
    >
      <button
        className="pdp-options__counter-open-button"
        type="button"
        aria-label="add first item"
        onClick={onAddClick}
      >
        <i className="icon icon-counter-modifier-big-plus"/>
      </button>
      <button
        type="button"
        aria-label="remove item"
        className="pdp-options__counter-subtract-button"
        onClick={onSubtractClick}
      >
        <i className="icon icon-counter-modifier-minus"/>
      </button>
      <div className="pdp-options__counter-count">
        {count || 0}
      </div>
      {!maxCountReached && (
        <button
          className="pdp-options__counter-add-button"
          type="button"
          aria-label="add another item"
          onClick={onAddClick}
        >
          <i className="icon icon-counter-modifier-plus"/>
        </button>
      )}
    </div>
  );
};

export default Counter;
